import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useQuery, useQueryClient } from "@tanstack/react-query";
import CreateModal from "./Components/CreateModal"
import InfoModal from "./Components/InformationModal"
import useRequest from "hook/useRequest";
import { ReqMethods } from "enums";
import {
    useKnowledgebase,
    useAssistantPlugins,
    useAssistantsList,
    useSharedAssistantsList,
    useUpdateAssistant,
    useUpdateAssistantAccountDefault,
    useUpdateDefaultAssistant,
    useFavouriteAssistant,
} from "queries/assistants";
import { useDeleteAssistantFile, useUploadAssistantFile, useUploadAssistantAudio } from "queries/chat";
import Promptlabels from '../UiPrompts/promptlabels/CustomPrompt';
import { useAgencyInfo } from "context/agency";
import EditModal from "./Components/EditModal"
import DeleteModal from "./Components/DeleteModal"
import Loader from "examples/Loader";
import "./style.css";
import filesubnmitted from "./folder-access.ico"
import MyDropzone from './MyDropzone'; // Import your Dropzone component
import localforage from 'localforage';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Tooltip } from '@mui/material';
import AddAWebsite from './Components/AddAWebsite'
import PushPinIcon from "@mui/icons-material/PushPin";

import { FormControlLabel, Icon, Switch } from '@mui/material';
import Tabs from "../components/Tabs";
import Accordian from '../components/Accordian/Accordian';

import googleDrive from "../../../assets/images/third-party/Images/googleDrive.png"
import dropBox from "../../../assets/images/third-party/Images/dropBox.png"
import { UploadFileOutlined, UploadFileRounded } from '@mui/icons-material';
import DropboxChooser from './Components/ThirdPartyServices/DropboxChooser';
import GoogleDrivePickers from './Components/ThirdPartyServices/GoogleDrivePickers';
import { useUserInfo } from 'context/user';
import { FaLink } from "react-icons/fa";
import KnowledgeBaseFiles from './Components/KBFiles/KnowledgeBaseFiles';
import AddCategory from './Components/Category/AddCategory';
import AddSubCategory from './Components/SubCategory/AddSubCategory';
import useDebouncedEffect from 'hook/debounce';


const index = () => {
    const [agency] = useAgencyInfo();
    const [user] = useUserInfo();
    const request = useRequest();
    const queryClient = useQueryClient();
    const [loadingItem, setLoadingItem] = useState(null); // Track which file is being deleted
    // State to control the confirmation dialog
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [fileToDelete, setFileToDelete] = useState(null);
    const [assistantForDelete, setAssistantForDelete] = useState(null);
    const [openModelPromptLabel, setopenModelPromptLabel] = useState(false);
    const [knowledgeBasePage, setKnowledgeBasePage] = useState(1);

    const { data: knowledgebaseQueryData, isFetching: knowledgebaseLoading } = useKnowledgebase(agency._id, knowledgeBasePage);
    const knowledgebaseData = { data: knowledgebaseQueryData?.data, pagination: knowledgebaseQueryData?.paginationData };
    const assistantNames = knowledgebaseQueryData?.assistantNames;
    // Preserves the old getKnowledgebaseData(page) contract that
    // KnowledgeBaseFiles' pagination calls via the onLoad prop.
    const getKnowledgebaseData = (page = 1) => setKnowledgeBasePage(page);

    const { data: pluginsCheckData } = useAssistantPlugins();
    // Matches the old behaviour exactly: pluginsdata starts empty and only
    // becomes agency.default_plugins once the plugins endpoint confirms.
    const pluginsdata = pluginsCheckData ? agency.default_plugins : [];

    // super_admin_settings isn't part of the assistant/chat/template domain
    // this migration owns, and it's only read here - inlined via useRequest()
    // rather than creating a new queries/*.js file for a single call site.
    const { data: supperAdminSettingsResponse } = useQuery({
        queryKey: ["super-admin-settings"],
        queryFn: async () => {
            const { response, error } = await request(ReqMethods.GET, "/super_admin_settings/");
            if (error) throw error;
            return response;
        },
    });
    const supperAdminData = supperAdminSettingsResponse?.data;

    const { mutateAsync: deleteKnowledgebaseFile } = useDeleteAssistantFile();

    const handleDeleteFile = async () => {
        if (!fileToDelete || !assistantForDelete) return;
        setLoadingItem(fileToDelete.id); // Set the loading state for the specific item
        try {
            const response = await deleteKnowledgebaseFile(
                { fileId: fileToDelete.id, assistantId: assistantForDelete.assistant_id },
                {
                    onSuccess: () => {
                        queryClient.invalidateQueries({ queryKey: ["assistants"] });
                        queryClient.invalidateQueries({ queryKey: ["knowledge-base"] });
                    },
                },
            );
            if (response) {
                setLoadingItem(null);
            }
        } catch (error) {
            console.error('Error deleting file:', error);
        } finally {
            setOpenConfirmDialog(false); // Close the dialog after handling the deletion
        }
    };

    const confirmDeleteFile = (fileItem, assistant) => {
        setFileToDelete(fileItem);
        setAssistantForDelete(assistant);
        setOpenConfirmDialog(true); // Open the confirmation dialog
    };

    // promptslabel.* is owned by queries/promptLabels.js (another fork) - its
    // usePromptLabels() hook doesn't cover either of these two queries (the
    // `pin=true` filter here, and the super-admin one's distinct
    // s_agency_id/hardcoded-agency_id shape below), so both are inlined via
    // useRequest() directly instead of editing that file.
    const categoryQuery = useQuery({
        // Not promptLabelKeys.list()'s own shape (that key is
        // ["prompt-labels", type, agencyId] and caches a flat array) - this
        // query caches the raw response envelope instead, so it needs a key
        // that doesn't collide with usePromptLabels()'s cache slot, or
        // whichever one fetched last overwrites the other with the wrong
        // shape (the exact cause of the EditModal/EditTemplate/CreateTemplate
        // ".filter is not a function" crash on this page).
        queryKey: ["prompt-labels", "pinned", "agency", agency._id],
        queryFn: async () => {
            const { response, error } = await request(ReqMethods.GET, "/promptslabel", { query: `type=agency&agency_id=${agency._id}&pin=true` });
            if (error) throw error;
            return response;
        },
    });
    const category = categoryQuery.data?.data || false;
    const loadcategory = () => queryClient.invalidateQueries({ queryKey: ["prompt-labels"] });

    const adminCategoryQuery = useQuery({
        // Same reasoning as categoryQuery above - avoid colliding with
        // usePromptLabels()'s cache slot shape.
        queryKey: ["prompt-labels", "pinned", "super-admin", agency._id],
        queryFn: async () => {
            const { response, error } = await request(ReqMethods.GET, "/promptslabel", { query: `type=super-admin&agency_id=superYxadminagency_id&s_agency_id=${agency._id}` });
            if (error) throw error;
            return response;
        },
    });
    const adminCategory = adminCategoryQuery.data?.data || false;
    const loadadmincategory = () => queryClient.invalidateQueries({ queryKey: ["prompt-labels"] });

    const handlerRefresh = () => {
        queryClient.invalidateQueries({ queryKey: ["assistants"] });
        queryClient.invalidateQueries({ queryKey: ["prompt-labels"] });
    }

    const [activeTab, setActiveTab] = useState(0);
    const [searchQuery, setSearchQuery] = useState("");

    const openUserAccountTemplates = (assistantName) => {
        setActiveTab(3); // "User/Account Templates" is at index 3
        setSearchQuery(assistantName);
    };

    return (
        <div className="container-alignment">

            <div style={{ textAlign: "right", padding: "20px 20px 0px 20px" }}>
                <CreateModal handleRefresh={handlerRefresh} supperAdminData={supperAdminData} pluginsdata={pluginsdata} />
                <InfoModal handleRefresh={handlerRefresh} supperAdminData={supperAdminData} />

            </div>
            <div style={{ marginTop: "10px" }}>

                <Tabs tabsData={[
                    { label: 'Your Live Agents', content: <AssistantTable openUserAccountTemplates={openUserAccountTemplates} supperAdminData={supperAdminData} pluginsdata={pluginsdata} /> },
                    { label: 'Your Templates', content: <Promptlabels setSearchQuery={setSearchQuery} searchQuery={searchQuery} handleRefresh={handlerRefresh} loadcategory={loadcategory} data={category.length > 0 && category} /> },
                    { label: 'Maybe* Shared Agents', content: <SuperadminAssistantTable supperAdminData={supperAdminData} pluginsdata={pluginsdata} /> },
                    { label: 'Maybe* Templates', content: <Promptlabels setSearchQuery={setSearchQuery} searchQuery={searchQuery} handleRefresh={handlerRefresh} loadcategory={loadadmincategory} data={adminCategory.length > 0 && adminCategory} fromAdmin={true} /> },
                    { label: 'Knowledge Base', content: <KnowledgeBaseFiles onLoad={getKnowledgebaseData} tabsData={knowledgebaseData.data} pagination={knowledgebaseData.pagination} assistantNames={assistantNames} waiting={knowledgebaseLoading} /> },
                ]}
                    activeTab={activeTab}
                    onTabChange={setActiveTab}
                />
            </div>

            {/* Confirmation Dialog */}
            <Dialog
                open={openConfirmDialog}
                onClose={() => setOpenConfirmDialog(false)}>
                <DialogTitle>Delete Confirmation</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete this file? This action cannot be undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenConfirmDialog(false)} color="secondary">
                        Cancel
                    </Button>
                    <Button onClick={handleDeleteFile} style={{ color: '#e31f1f' }} autoFocus>
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

const AssistantTable = ({ supperAdminData, pluginsdata, openUserAccountTemplates }) => {

    let filteredData = [];
    const [agency] = useAgencyInfo();
    const queryClient = useQueryClient();
    const uploadAssistantFile = useUploadAssistantFile();
    const uploadAssistantAudio = useUploadAssistantAudio();

    const [searchQuery, setSearchQuery] = useState(""); // State for search input

    const [alertModel, setAlertModel] = useState(false);
    const [successModel, setSuccessModel] = useState(false);
    const [addFileInAssistant, setAddFileInAssistant] = useState();
    const [toggleOption, setToggleOption] = useState(false);
    const [toggleOptionStatic, setToggleOptionStatic] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [profileId, setProfileId] = useState(null);
    const [userName, setUserName] = useState(null);
    const [filterOption, setFilterOption] = useState('');
    // Mirrors the old loadAssistant(page, type, search) args - whatever onLoad
    // was last called with is what the query key (and thus the request) uses.
    const [queryParams, setQueryParams] = useState({ page: 1, type: '', search: undefined });

    const itemsPerPage = 10; // Number of items per page

    const { data: assistantsResponse, isFetching: waiting } = useAssistantsList({
        agencyId: agency._id,
        page: queryParams.page,
        type: queryParams.type,
        search: queryParams.search,
    });

    const currentItems = assistantsResponse?.data?.length > 0 && assistantsResponse?.data;
    const totalPages = assistantsResponse?.totalPages || 1;
    const currentPage = queryParams.page;

    // Same contract the old parent-owned loadAssistant() had, so every
    // child (EditModal, DeleteModal, AddAWebsite, pin/toggle handlers...)
    // keeps calling onLoad(page, type, search) unchanged.
    const onLoad = (page = 1, type = '', search) => {
        setQueryParams({ page, type, search });
        queryClient.invalidateQueries({ queryKey: ["assistants"] });
    };

    const [toggleCheckedState, setToggleCheckedState] = useState(() => {
        const initialToggleState = {};
        if (currentItems?.length)
            currentItems?.forEach((item) => {
                initialToggleState[item._id] = item?.status; // Initialize all switches to false (unchecked)
            });
        return initialToggleState;
    });

    const { mutateAsync: toggleAssistantStatus } = useUpdateAssistant();

    // Handle the switch change for each row
    const handleToggleChange = async (item) => {
        const payload = {
            _id: item?._id,
            status: !item?.status,
        };
        const { response } = await toggleAssistantStatus({ payload })
        if (response?.success)
            onLoad(1);
    };

    useDebouncedEffect(
        () => {
            onLoad(1, "", searchQuery)
        },
        [searchQuery],
        1000,
        { skipFirstRun: true }
    );

    const handlePageChange = (pageNumber) => {
        if (pageNumber === currentPage) return;
        onLoad(pageNumber, filterOption, searchQuery);
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            onLoad(currentPage + 1, filterOption, searchQuery);
        }
    };

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            onLoad(currentPage - 1, filterOption, searchQuery);
        }
    };

    // Calculate start and end of pagination buttons
    const maxButtonsToShow = 5;
    const startPage = useMemo(() => Math.max(currentPage - Math.floor(maxButtonsToShow / 2), 1), [currentPage]);
    const endPage = useMemo(() => Math.min(startPage + maxButtonsToShow - 1, totalPages), [startPage, totalPages]);

    const UploadFile = async (files) => {
        try {
            const user = await localforage.getItem('user').then((userObject) => {
                if (userObject) {
                    return userObject;
                } else {
                    console.log('No user found in localForage');
                }
            })
            const formData = new FormData();
            for (let file of files) {
                formData.append('file', file.file);
            }

            const assistantIds = [addFileInAssistant];
            formData.append('profile_id', agency?.ghl ? agency.ghl.location_id : agency.location_id)
            formData.append('username', 'AgencyUser')
            formData.append('model_name', "openai/gpt-4o")
            formData.append('assistant_ids', JSON.stringify(assistantIds));

            const response = await uploadAssistantFile(formData, { toaster: true });

            if (response) {
                setAlertModel(false);
                onLoad();
                setSuccessModel(true)
            }
        } catch (error) {
            console.log(error);
        }
    }



    const handleToggle = (index) => {
        // setSelectedIndex(selectedIndex === index ? null : index);
        setSelectedIndex(index)
    };

    useEffect(() => {
        localforage.getItem('agency')
            .then((agency) => {
                if (agency && agency._id) {
                    setProfileId(agency._id); // Set the _id in state
                } else {
                    console.log('Agency object or _id not found');
                }
            })
            .catch((error) => {
                console.error('Error fetching agency:', error);
            });

        localforage.getItem('user')
            .then((user) => {
                if (user && user.username) {
                    setUserName(user.username); // Set the _id in state
                } else {
                    console.log('user object or username not found');
                }
            })
            .catch((error) => {
                console.error('Error fetching user:', error);
            });
    }, []);

    const contextuploadFilefrominput = async (files, profileId, userName, assistant_ids) => {

        const audioformData = new FormData();
        const formData = new FormData();
        const audiofilestype = [
            'audio/mpeg',  // mp3
            'video/mp4',   // mp4
            'video/mpeg',  // mpeg
            'audio/mp4',   // m4a
            'audio/wav'    // wav
        ];
        const audiofiles = [];
        const otherFiles = [];
        const assistants = [assistant_ids]
        for (let index = 0; index < files.length; index++) {
            const fileType = files[index]?.file ? files[index]?.file.type : files[index]?.type;

            if (audiofilestype.includes(fileType)) {
                audiofiles.push(files[index]);
            } else {
                otherFiles.push(files[index]);
            }
        }

        // Append allowed files to formData
        for (let file of audiofiles) {
            audioformData.append('file', file?.file ? file?.file : file);
            audioformData.append('translate', file.isChecked);
        }
        for (let file of otherFiles) {
            formData.append('file', file.file ? file.file : file);
        }

        audioformData.append('profile_id', profileId)
        audioformData.append('username', 'AgencyUser')
        audioformData.append('model_name', "openai/gpt-4o")
        formData.append('profile_id', profileId)
        formData.append('username', 'AgencyUser')
        formData.append('assistant_ids', JSON.stringify(assistants))
        formData.append('model_name', "openai/gpt-4o")



        // You can now handle `otherFiles` array separately if needed
        if (audiofiles.length > 0) {
            const { response, error } = await uploadAssistantAudio(audioformData);
            if (error) {
                console.log(error);
            } else if (response) {
                setSuccessModel(true)
                onLoad();
            }
        }
        if (otherFiles.length > 0) {
            const { response, error } = await uploadAssistantFile(formData);
            if (error) {
                console.log(error);
            } else if (response) {
                setSuccessModel(true)
                onLoad();
                return "uploaded"
            }
        }
        return "uploaded";
    }

    const files_recieved_from_child = async (files, type, assistant_id) => {
        if (type == "GoogleDrive") {
            contextuploadFilefrominput(files, profileId, userName, assistant_id)

        }
        if (type == "dropbox") {
            if (files?.length > 0) {
                contextuploadFilefrominput(files, profileId, userName, assistant_id)

            }
        }
    };

    const dropDownClose = useRef();

    useEffect(() => {
        if (!dropDownClose.current) return;

        const handleClickOutside = (event) => {
            if (!dropDownClose.current.contains(event.target)) {
                setSelectedIndex(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    });


    const staticDropDownClose = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (staticDropDownClose.current && !staticDropDownClose.current.contains(event.target)) {
                setToggleOptionStatic(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    const applyfilter = (val) => {
        if (val === filterOption) return;
        onLoad(1, val);
        setFilterOption(val)
    }

    const { mutateAsync: updateAssistantAccountDefault } = useUpdateAssistantAccountDefault();
    const handleToggleChangedefaultaccount = async (assistantId, profileId, currentState, assistant_type) => {
        const newState = !currentState; // Toggle the current state
        const { response, error } = await updateAssistantAccountDefault({
            assistantid: assistantId,
            profile_id: profileId,
            assitentdefault_value_change: newState,
            assistant_type: assistant_type
        });
        if (error) {
            console.error("Error updating assistant:", error);
            return;
        }
        console.log("Updated successfully");
        // Optionally refresh the data or update UI here
        onLoad();
    };
    const { mutateAsync: updateDefaultAssistantUi } = useUpdateDefaultAssistant();
    const handleToggleChangedefaultassistant = async (assistantid, currentState) => {
        const newState = !currentState; // Toggle the current state
        const { response, error } = await updateDefaultAssistantUi({
            assistantid: assistantid,
            ui_enable: newState // Send the new state
        });
        if (error) {
            console.error("Error updating assistant:", error);
            return;
        }
        console.log("Updated successfully");
        // Optionally refresh the data or update UI here
        onLoad();
    }

    const { mutateAsync: favouriteAssistant } = useFavouriteAssistant();
    const handlePinClick = async (assistant_id, template_id = '') => {
        const payload = {
            assistant_id,
            template_id,
        };
        const { response } = await favouriteAssistant(payload);
        if (response?.success) {
            onLoad(1);
        }
    };

    if (!Array.isArray(currentItems)) {
        return (<>
            {waiting ? (<Loader />) : (<><div className="w-100" style={{ marginTop: "50px" }}>
                <div style={{ position: "relative", marginBottom: "20px", display: "flex", justifyContent: "space-between" }}>
                    <div>
                        <div style={{ position: "absolute", left: "10px", top: "20px" }}>
                            <svg
                                width="25"
                                height="25"
                                viewBox="0 0 15 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <g clipPath="url(#clip0_282_92)">
                                    <path
                                        d="M15 13.2955L12.3767 10.7727C13.1166 9.68182 13.5202 8.31818 13.5202 6.88636C13.5202 3.06818 10.4933 0 6.79372 0C3.09417 0 0 3.06818 0 6.88636C0 10.7045 3.02691 13.7727 6.79372 13.7727C8.27354 13.7727 9.61883 13.2955 10.6951 12.4773L13.3184 15.0682L15 13.2955ZM2.35426 6.88636C2.35426 4.43182 4.30493 2.45455 6.72646 2.45455C9.14798 2.45455 11.0987 4.43182 11.0987 6.88636C11.0987 9.34091 9.14798 11.3182 6.72646 11.3182C4.3722 11.3182 2.35426 9.34091 2.35426 6.88636Z"
                                        fill="#E5E5E5"
                                    />
                                </g>
                                <defs>
                                    <clipPath id="clip0_282_92">
                                        <rect width="15" height="15" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <input
                            type="text"
                            placeholder="Search by name..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            style={{
                                padding: "30px 45px",
                                width: "100%",
                                fontSize: "18px",
                                boxSizing: "border-box",
                                border: "1px solid #ccc",
                                borderRadius: "5px",
                            }}
                        />
                    </div>
                    <div style={{ textAlign: "right" }}>
                        <div>
                            <div style={{ position: "absolute", left: "10px", top: "20px" }}>
                                <svg
                                    width="25"
                                    height="25"
                                    viewBox="0 0 15 15"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <g clipPath="url(#clip0_282_92)">
                                        <path
                                            d="M15 13.2955L12.3767 10.7727C13.1166 9.68182 13.5202 8.31818 13.5202 6.88636C13.5202 3.06818 10.4933 0 6.79372 0C3.09417 0 0 3.06818 0 6.88636C0 10.7045 3.02691 13.7727 6.79372 13.7727C8.27354 13.7727 9.61883 13.2955 10.6951 12.4773L13.3184 15.0682L15 13.2955ZM2.35426 6.88636C2.35426 4.43182 4.30493 2.45455 6.72646 2.45455C9.14798 2.45455 11.0987 4.43182 11.0987 6.88636C11.0987 9.34091 9.14798 11.3182 6.72646 11.3182C4.3722 11.3182 2.35426 9.34091 2.35426 6.88636Z"
                                            fill="#E5E5E5"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_282_92">
                                            <rect width="15" height="15" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>
                            <select
                                value={filterOption}
                                onChange={(e) => applyfilter(e.target.value)}
                                style={{
                                    padding: "18px 57px",
                                    width: "100%",
                                    fontSize: "18px",
                                    boxSizing: "border-box",
                                    border: "1px solid #ccc",
                                    borderRadius: "5px",
                                }}
                            >
                                <option value="">Filter by...</option>
                                <option value={"agency"}>All Accounts</option>
                                <option value={"account"}>Account Specific</option>
                                <option value={"user"}>User Specific</option>
                                <option value={"automation"}>Automation</option>
                                {/* Add more options as needed */}
                            </select>
                        </div>
                    </div>

                </div>
                <div className="d-flex w-100">
                    <p className="p-20-px w-20-per text-left">Name</p>
                    {/* <p className="p-20-px w-20-per text-left">Tag</p> */}
                    <p className="p-20-px w-20-per text-left">Type</p>
                    <p className="p-20-px w-20-per text-left">Account Name</p>
                    <p className="p-20-px w-20-per text-left">User Name</p>
                    <p className="p-20-px w-20-per text-left">Date Created</p>

                    <p className="p-20-px w-20-per text-left"></p>
                </div>
                <div className="d-flex w-100">
                    <p className="w-100 text-center">data Not Found</p>

                </div>
            </div></>)
            }
        </>);
    }

    console.log('currentItems', currentItems)

    return (
        <>
            {waiting ? (
                <Loader />
            ) : (
                <>
                    {/* Search Input */}
                    <div style={{ position: "relative", marginBottom: "20px", display: "flex", justifyContent: "space-between" }}>
                        <div>
                            <div style={{ position: "absolute", left: "10px", top: "20px" }}>
                                <svg
                                    width="25"
                                    height="25"
                                    viewBox="0 0 15 15"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <g clipPath="url(#clip0_282_92)">
                                        <path
                                            d="M15 13.2955L12.3767 10.7727C13.1166 9.68182 13.5202 8.31818 13.5202 6.88636C13.5202 3.06818 10.4933 0 6.79372 0C3.09417 0 0 3.06818 0 6.88636C0 10.7045 3.02691 13.7727 6.79372 13.7727C8.27354 13.7727 9.61883 13.2955 10.6951 12.4773L13.3184 15.0682L15 13.2955ZM2.35426 6.88636C2.35426 4.43182 4.30493 2.45455 6.72646 2.45455C9.14798 2.45455 11.0987 4.43182 11.0987 6.88636C11.0987 9.34091 9.14798 11.3182 6.72646 11.3182C4.3722 11.3182 2.35426 9.34091 2.35426 6.88636Z"
                                            fill="#E5E5E5"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_282_92">
                                            <rect width="15" height="15" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>
                            <input
                                type="text"
                                placeholder="Search by name..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                style={{
                                    padding: "30px 45px",
                                    width: "100%",
                                    fontSize: "18px",
                                    boxSizing: "border-box",
                                    border: "1px solid #ccc",
                                    borderRadius: "5px",
                                }}
                            />
                        </div>
                        <div style={{ textAlign: "right" }}>
                            <div>
                                <div style={{ position: "absolute", left: "10px", top: "20px" }}>
                                    <svg
                                        width="25"
                                        height="25"
                                        viewBox="0 0 15 15"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <g clipPath="url(#clip0_282_92)">
                                            <path
                                                d="M15 13.2955L12.3767 10.7727C13.1166 9.68182 13.5202 8.31818 13.5202 6.88636C13.5202 3.06818 10.4933 0 6.79372 0C3.09417 0 0 3.06818 0 6.88636C0 10.7045 3.02691 13.7727 6.79372 13.7727C8.27354 13.7727 9.61883 13.2955 10.6951 12.4773L13.3184 15.0682L15 13.2955ZM2.35426 6.88636C2.35426 4.43182 4.30493 2.45455 6.72646 2.45455C9.14798 2.45455 11.0987 4.43182 11.0987 6.88636C11.0987 9.34091 9.14798 11.3182 6.72646 11.3182C4.3722 11.3182 2.35426 9.34091 2.35426 6.88636Z"
                                                fill="#E5E5E5"
                                            />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_282_92">
                                                <rect width="15" height="15" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </div>
                                <select
                                    value={filterOption}
                                    onChange={(e) => applyfilter(e.target.value)}
                                    style={{
                                        padding: "18px 57px",
                                        width: "100%",
                                        fontSize: "18px",
                                        boxSizing: "border-box",
                                        border: "1px solid #ccc",
                                        borderRadius: "5px",
                                    }}
                                >
                                    <option value="">Filter by...</option>
                                    <option value={"agency"}>All Accounts</option>
                                    <option value={"account"}>Account Specific</option>
                                    <option value={"user"}>User Specific</option>
                                    <option value={"automation"}>Automation</option>
                                    {/* Add more options as needed */}
                                </select>
                            </div>
                        </div>

                    </div>

                    <div className="w-100">
                        <div className="d-flex w-100">
                            <p className="p-20-px w-20-per text-left">Name</p>
                            {/* <p className="p-20-px w-20-per text-left">Tag</p> */}
                            <p className="p-20-px w-20-per text-left">Type</p>
                            <p className="p-20-px w-20-per text-left">Category</p>
                            <p className="p-20-px w-20-per text-left">Tags</p>
                            <p className="p-20-px w-20-per text-left">Account Name</p>
                            <p className="p-20-px w-20-per text-left">User Name</p>
                            <p className="p-20-px w-20-per text-left">Date Created</p>

                            <p className="p-20-px w-20-per text-left"></p>
                        </div>
                        <div>
                            {currentItems?.length > 0 ? (
                                currentItems?.sort((a, b) => (a.assist_type === 'agency_task_gen' ? -1 : b.assist_type === 'agency_task_gen' ? 1 : 0))
                                    .map((item, index) => (
                                        <div className="equalheight d-flex w-100 tablebody-row" key={item._id || index}>
                                            <div className="p-20-px text-black text-bold text-left w-20-per">
                                                {item.assistant_name}
                                            </div>
                                            <div className="p-20-px text-black text-left w-20-per" style={{ textTransform: 'capitalize' }}>
                                                {
                                                    item?.assist_type === 'agency_task_gen'
                                                        ? 'Task Helper'
                                                        : item?.assist_type === 'agency'
                                                            ? 'All Account'
                                                            : filterOption === 'automation'
                                                                ? 'Automation'
                                                                : item?.assist_type
                                                }
                                            </div>

                                            <div className="p-20-px text-black text-left w-20-per" style={{ display: 'flex', alignItems: 'center' }}>
                                                {(() => {
                                                    // Handle category as array - find category for current agency
                                                    let categoryToDisplay = null;

                                                    if (Array.isArray(item?.category)) {
                                                        categoryToDisplay = item.category.find(cat => cat.agency_id === agency._id);
                                                    } else if (item?.category && item?.category.agency_id === agency._id) {
                                                        // Handle legacy single category object
                                                        categoryToDisplay = item.category;
                                                    }

                                                    return categoryToDisplay ? (
                                                        <span style={{ background: categoryToDisplay?.color, padding: '5px 15px', borderRadius: '20px', marginRight: '10px' }}>
                                                            {categoryToDisplay?.name}
                                                        </span>
                                                    ) : null;
                                                })()}
                                                <AddCategory item={item} handleRefresh={onLoad} />
                                            </div>
                                            <div className="p-20-px text-black text-left w-20-per" style={{ display: 'flex', alignItems: 'center' }}>
                                                <span style={{ display: "flex" }}>
                                                    {item?.subCategory?.filter(cat => cat?.agency_id === agency._id && agency.SubCategories?.some(sub => cat.id === sub.id))?.slice(0, 1).map((data, index) => (
                                                        <span
                                                            key={index}
                                                            style={{ background: '#F3F4F6', padding: '5px 15px', borderRadius: '20px', marginRight: '10px', marginBottom: '5px', display: 'inline-flex', alignItems: 'center', gap: '8px' }}
                                                        >
                                                            {data?.name}
                                                        </span>
                                                    ))}

                                                    {item?.subCategory?.filter(cat => cat?.agency_id === agency._id && agency.SubCategories?.some(sub => cat.id === sub.id))?.length > 1 && (
                                                        <span
                                                            style={{ background: '#E7ECF3', padding: '5px 15px', borderRadius: '20px', marginRight: '10px', marginBottom: '5px', cursor: 'default' }}
                                                        >
                                                            {item?.subCategory?.filter(cat => cat?.agency_id === agency._id && agency.SubCategories?.some(sub => cat.id === sub.id))?.length - 1} more
                                                        </span>
                                                    )}
                                                </span>
                                                <AddSubCategory item={item} handleRefresh={onLoad} />
                                            </div>


                                            <div className="p-20-px text-black text-left w-20-per" style={{ overflow: "auto" }}>
                                                {item?.accounts?.map((account) => (<>

                                                    <span>{account?.business_name}</span>
                                                </>))}
                                            </div>
                                            <div className="p-20-px text-black text-left w-20-per" style={{ overflow: "auto" }}>

                                                {item?.chats_users?.map((user) => (<>

                                                    <span>{user?.userName}</span>
                                                </>))}
                                            </div>
                                            <div className="p-20-px text-black text-left w-20-per">
                                                {new Date(item?.createdAt).toLocaleString()}
                                            </div>

                                            <div className="p-20-px text-black text-right w-20-per">
                                                <div style={{ display: "flex", justifyContent: "center" }}>
                                                    {/* {(item?.assist_type === "account" || item?.assist_type === "agency") &&
                                                        <Tooltip title="Default Agent" arrow>
                                                            <FormControlLabel
                                                                control={
                                                                    <Switch
                                                                        checked={item?.finderofdefaultvalue?.default_assistant === undefined ? false : item?.finderofdefaultvalue?.default_assistant} // Ensure it defaults to `false` if undefined
                                                                        onChange={() => handleToggleChangedefaultaccount(
                                                                            item.assistant_id,
                                                                            item.profile_id,
                                                                            item?.finderofdefaultvalue?.default_assistant === undefined ? false : item?.finderofdefaultvalue?.default_assistant,
                                                                            item?.assist_type
                                                                        )}
                                                                    />
                                                                }
                                                                label=""
                                                            />
                                                        </Tooltip>
                                                    } */}
                                                    {(item?.assist_type !== 'account' || (item?.assist_type === 'account' && item?.template_id)) && item.assistant_name !== 'Custom Task' && <Tooltip title="Pin" arrow>
                                                        <div style={{ marginInline: '22px', cursor: "pointer" }} onClick={() => handlePinClick(item.assistant_id, item?.template_id)}>
                                                            <PushPinIcon sx={{ color: item?.pin ? "#000" : "#c9c9c9", fontSize: "26px" }} />
                                                        </div>
                                                    </Tooltip>}
                                                    {
                                                        item?.assist_type !== 'agency_task_gen' && (
                                                            <Tooltip title={item?.category ? "Chat UI" : "Add a category first"} arrow>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Switch
                                                                            checked={item?.ui_enable}
                                                                            onChange={() => handleToggleChangedefaultassistant(
                                                                                item._id,
                                                                                item?.ui_enable // Pass current state
                                                                            )}
                                                                            disabled={!item?.category} // Disable if no category
                                                                        />
                                                                    }
                                                                    label=""
                                                                />
                                                            </Tooltip>
                                                        )
                                                    }

                                                    {item?.assist_type !== 'agency_task_gen' && (
                                                        <Tooltip title="On/Off" arrow>
                                                            <FormControlLabel
                                                                control={
                                                                    <Switch
                                                                        checked={item?.status}
                                                                        onChange={() => handleToggleChange(item)}
                                                                    />
                                                                }
                                                                label=""
                                                            />
                                                        </Tooltip>
                                                    )}
                                                    {item.type !== 'super-admin' && (
                                                        <div style={{ display: "flex" }}>
                                                            {item?.readonly === true && (
                                                                <span
                                                                    className="cursor-pointer"
                                                                    onClick={() => handleToggle(index)}
                                                                    style={{ position: "relative" }}
                                                                >
                                                                    <Icon>upload</Icon>
                                                                    {selectedIndex === index && (
                                                                        <div className="v3_dropdown" ref={dropDownClose}>
                                                                            <span style={{ padding: "12px" }}>
                                                                                <FaLink style={{ marginRight: "7px", marginLeft: '4px' }} />
                                                                                <AddAWebsite assistant_id={item?.assistant_id} setSelectedIndex={setSelectedIndex} handlerRefresh={onLoad} />
                                                                            </span>
                                                                            <span>
                                                                                <img src={googleDrive} alt="googleDrive" style={{ marginRight: "7px" }} />
                                                                                <GoogleDrivePickers setSelectedIndex={setSelectedIndex} files_send_to_parent={files_recieved_from_child} assistant_id={item?.assistant_id} />
                                                                            </span>
                                                                            <span>
                                                                                <img src={dropBox} alt="Drop Box" style={{ marginRight: "7px" }} />
                                                                                <DropboxChooser setSelectedIndex={setSelectedIndex} files_send_to_parent={files_recieved_from_child} assistant_id={item?.assistant_id} />
                                                                            </span>
                                                                            <span
                                                                                onClick={() => {
                                                                                    setAlertModel(true);
                                                                                    setAddFileInAssistant(item?.assistant_id);
                                                                                }}
                                                                                style={{
                                                                                    borderBottom: "1px solid #E5E5E5",
                                                                                    borderTop: "1px solid #E5E5E5",
                                                                                }}
                                                                            >
                                                                                <div style={{ paddingRight: "7px" }}>
                                                                                    <UploadFileRounded fontSize="18px" />
                                                                                </div>
                                                                                Upload From Computer
                                                                            </span>


                                                                        </div>
                                                                    )}
                                                                </span>
                                                            )}
                                                            {item?.assist_type !== 'agency_task_gen' && (
                                                                <>
                                                                    {item?.assist_type !== 'account-only' && item.assist_type !== 'super-admin' && (
                                                                        <div className="cursor-pointer" style={{ margin: "0px 10px" }}>
                                                                            <EditModal openUserAccountTemplates={openUserAccountTemplates} item={item} handleRefresh={onLoad} supperAdminData={supperAdminData} assistant_type={item?.assist_type} pluginsdata={pluginsdata} />
                                                                        </div>
                                                                    )}
                                                                    <div className="cursor-pointer">
                                                                        <DeleteModal item={item} handleRefresh={onLoad} />
                                                                    </div>
                                                                </>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            </div >
                                        </div >
                                    ))
                            ) : (
                                <p className="text-center">No Assistant found</p>
                            )}
                        </div >
                    </div >

                    {/* Pagination Controls */}
                    < div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
                        <button
                            onClick={handlePreviousPage}
                            disabled={currentPage === 1}
                            style={{
                                padding: "8px 16px",
                                margin: "0 5px",
                                backgroundColor: "white",
                                color: "black",
                                border: "1px solid black",
                                borderRadius: "4px",
                                cursor: currentPage === 1 ? "not-allowed" : "pointer",
                                opacity: currentPage === 1 ? 0.6 : 1,
                            }}
                        >
                            Previous
                        </button>

                        {
                            endPage && startPage && [...Array(endPage - startPage + 1)]?.map((_, index) => {
                                const pageNumber = startPage + index;
                                return (
                                    <button
                                        key={pageNumber}
                                        onClick={() => handlePageChange(pageNumber)}
                                        style={{
                                            padding: "8px 16px",
                                            margin: "0 5px",
                                            backgroundColor: pageNumber === currentPage ? "black" : "white",
                                            color: pageNumber === currentPage ? "white" : "black",
                                            border: pageNumber === currentPage ? "1px solid white" : "1px solid black",
                                            borderRadius: "4px",
                                            cursor: "pointer",
                                        }}
                                    >
                                        {pageNumber}
                                    </button>
                                );
                            })
                        }

                        <button
                            onClick={handleNextPage}
                            disabled={currentPage === totalPages}
                            style={{
                                padding: "8px 16px",
                                margin: "0 5px",
                                backgroundColor: "white",
                                color: "black",
                                border: "1px solid black",
                                borderRadius: "4px",
                                cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                                opacity: currentPage === totalPages ? 0.6 : 1,
                            }}
                        >
                            Next
                        </button>
                    </div >
                    {alertModel && <>
                        <div className="modal-zz" onClick={() => setAlertModel(false)}>
                            <div className="modal-content-zz" onClick={(e) => e.stopPropagation()}>
                                <p
                                    style={{
                                        position: "absolute",
                                        right: 5,
                                        width: "12px",
                                        top: "10px",
                                        height: "12px",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => setAlertModel(false)}
                                >
                                </p>

                                <MyDropzone UploadFile={UploadFile} />
                            </div>
                        </div>
                    </>}
                    {
                        successModel && <>
                            <div className="modal-zz" onClick={() => setSuccessModel(false)}>
                                <div className="modal-content-zz" onClick={(e) => e.stopPropagation()}>
                                    <p style={{
                                        position: "absolute",
                                        right: 5,
                                        width: "12px",
                                        top: "10px",
                                        height: "12px",
                                        cursor: "pointer",
                                    }} onClick={() => setSuccessModel(false)}>
                                        X
                                    </p>
                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                        <img src={filesubnmitted} width={"200px"} height={"200px"} />
                                        <h1 className="text-center">File(s) are Submitted!</h1>
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                </>
            )
            }
        </>

    );
};

const SuperadminAssistantTable = ({ supperAdminData, pluginsdata }) => {
    let filteredData = [];
    const [agency, Update] = useAgencyInfo();
    const queryClient = useQueryClient();
    const uploadAssistantFile = useUploadAssistantFile();
    const uploadAssistantAudio = useUploadAssistantAudio();

    const [searchQuery, setSearchQuery] = useState(""); // State for search input

    const [alertModel, setAlertModel] = useState(false);
    const [successModel, setSuccessModel] = useState(false);
    const [addFileInAssistant, setAddFileInAssistant] = useState();
    const [toggleOption, setToggleOption] = useState(false);
    const [toggleOptionStatic, setToggleOptionStatic] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [profileId, setProfileId] = useState(null);
    const [userName, setUserName] = useState(null);
    const [filterOption, setFilterOption] = useState('');
    // Mirrors the old superAdminAssistant(page, search) args exactly - this
    // only ever took 2 params, so applyfilter's call further below (which
    // passes its value positionally as "search", not a type/filter) keeps
    // its pre-existing behaviour unchanged.
    const [queryParams, setQueryParams] = useState({ page: 1, search: undefined });

    const { data: assistantsResponse, isFetching: waiting } = useSharedAssistantsList({
        page: queryParams.page,
        search: queryParams.search,
    });

    const currentPage = queryParams.page;
    const totalPages = assistantsResponse?.totalPages || 1;
    const currentItems = assistantsResponse?.data?.length > 0 && assistantsResponse?.data;

    const onLoad = (page = 1, search) => {
        setQueryParams({ page, search });
        queryClient.invalidateQueries({ queryKey: ["assistants"] });
    };

    const [toggleCheckedState, setToggleCheckedState] = useState(() => {
        const initialToggleState = {};
        currentItems.length > 0 && currentItems.forEach((item) => {
            initialToggleState[item._id] = item.status; // Initialize all switches to false (unchecked)
        });
        return initialToggleState;
    });

    const { mutateAsync: toggleAssistantStatus } = useUpdateAssistant();

    // Handle the switch change for each row
    const handleToggleChange = async (id) => {
        // First, update the state with the new toggle value
        setToggleCheckedState((prevState) => {
            const newState = {
                ...prevState,
                [id]: !prevState[id],
            };
            const payload = {
                _id: id,
                status: newState[id], // Get the updated status directly from newState
            };
            toggleAssistantStatus({ payload })
                .then((newAssistant) => {
                    if (newAssistant) {
                        onLoad();
                    }
                })
                .catch((error) => {
                    console.error("Error updating assistant:", error);
                });

            return newState;
        });
    };

    const { mutateAsync: updateSuperAdminAgents } = useUpdateAssistant();

    const handleToggleChangeSuperAdmin = async (id) => {
        try {
            // Check if the agent ID exists in superAdminAgents
            const isAgentActive = agency.superAdminAgents.includes(id);

            // Toggle the state
            const updatedState = !isAgentActive;

            // Update the superAdminAgents array
            const updatedSuperAdminAgents = updatedState
                ? [...agency.superAdminAgents, id] // Add the agent ID if toggled to true
                : agency.superAdminAgents.filter(agentId => agentId !== id); // Remove the agent ID if toggled to false

            // Prepare the payload
            const payload = {
                _id: id, // Agent ID
                agency_id: agency._id, // Agency ID
                superAdminAgents: updatedSuperAdminAgents, // Updated superAdminAgents array
            };

            // Send the updated data to the backend
            const response = await updateSuperAdminAgents({ payload });

            if (response) {
                console.log("Updated successfully", response?.response?.data);
                Update(response?.response?.data);
                // onLoad(); // Refresh the data or update the UI
            }
        } catch (error) {
            console.error("Error updating superAdminAgents:", error);
        }
    };

    const handlePageChange = (pageNumber) => {
        if (pageNumber === currentPage) return;
        onLoad(pageNumber);
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            // NOTE: pre-existing typo - `onload` (not `onLoad`) is undefined,
            // so Next has always been a no-op here. Left as-is.
            onload(currentPage + 1);
        }
    };

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            onLoad(currentPage - 1);
        }
    };

    // Calculate start and end of pagination buttons
    const maxButtonsToShow = 5;
    const startPage = Math.max(currentPage - Math.floor(maxButtonsToShow / 2), 1);
    const endPage = Math.min(startPage + maxButtonsToShow - 1, totalPages);

    const UploadFile = async (files) => {
        try {
            const user = await localforage.getItem('user').then((userObject) => {
                if (userObject) {
                    return userObject;
                } else {
                    console.log('No user found in localForage');
                }
            })
            const formData = new FormData();
            for (let file of files) {
                formData.append('file', file.file);
            }

            const assistantIds = [addFileInAssistant];
            formData.append('profile_id', agency?.ghl ? agency.ghl.location_id : agency.location_id)
            formData.append('username', 'AgencyUser')
            formData.append('model_name', "openai/gpt-4o")
            formData.append('assistant_ids', JSON.stringify(assistantIds));

            const response = await uploadAssistantFile(formData, { toaster: true });

            if (response) {
                setAlertModel(false);
                onLoad();
                setSuccessModel(true)
            }
        } catch (error) {
            console.log(error);
        }
    }



    const handleToggle = (index) => {
        // setSelectedIndex(selectedIndex === index ? null : index);
        setSelectedIndex(index)
    };

    useEffect(() => {
        localforage.getItem('agency')
            .then((agency) => {
                if (agency && agency._id) {
                    setProfileId(agency._id); // Set the _id in state
                } else {
                    console.log('Agency object or _id not found');
                }
            })
            .catch((error) => {
                console.error('Error fetching agency:', error);
            });

        localforage.getItem('user')
            .then((user) => {
                if (user && user.username) {
                    setUserName(user.username); // Set the _id in state
                } else {
                    console.log('user object or username not found');
                }
            })
            .catch((error) => {
                console.error('Error fetching user:', error);
            });
    }, []);

    const contextuploadFilefrominput = async (files, profileId, userName, assistant_ids) => {

        const audioformData = new FormData();
        const formData = new FormData();
        const audiofilestype = [
            'audio/mpeg',  // mp3
            'video/mp4',   // mp4
            'video/mpeg',  // mpeg
            'audio/mp4',   // m4a
            'audio/wav'    // wav
        ];
        const audiofiles = [];
        const otherFiles = [];
        const assistants = [assistant_ids]
        for (let index = 0; index < files.length; index++) {
            const fileType = files[index]?.file ? files[index]?.file.type : files[index]?.type;

            if (audiofilestype.includes(fileType)) {
                audiofiles.push(files[index]);
            } else {
                otherFiles.push(files[index]);
            }
        }

        // Append allowed files to formData
        for (let file of audiofiles) {
            audioformData.append('file', file?.file ? file?.file : file);
            audioformData.append('translate', file.isChecked);
        }
        for (let file of otherFiles) {
            formData.append('file', file.file ? file.file : file);
        }

        audioformData.append('profile_id', profileId)
        audioformData.append('username', 'AgencyUser')
        audioformData.append('model_name', "openai/gpt-4o")
        formData.append('profile_id', profileId)
        formData.append('username', 'AgencyUser')
        formData.append('assistant_ids', JSON.stringify(assistants))
        formData.append('model_name', "openai/gpt-4o")



        // You can now handle `otherFiles` array separately if needed
        if (audiofiles.length > 0) {
            const { response, error } = await uploadAssistantAudio(audioformData);
            if (error) {
                console.log(error);
            } else if (response) {
                setSuccessModel(true)
                onLoad();
            }
        }
        if (otherFiles.length > 0) {
            const { response, error } = await uploadAssistantFile(formData);
            if (error) {
                console.log(error);
            } else if (response) {
                setSuccessModel(true)
                onLoad();
                return "uploaded"
            }
        }
        return "uploaded";
    }

    const files_recieved_from_child = async (files, type, assistant_id) => {
        if (type == "GoogleDrive") {
            contextuploadFilefrominput(files, profileId, userName, assistant_id)

        }
        if (type == "dropbox") {
            if (files?.length > 0) {
                contextuploadFilefrominput(files, profileId, userName, assistant_id)

            }
        }
    };

    const dropDownClose = useRef();

    useEffect(() => {
        if (!dropDownClose.current) return;

        const handleClickOutside = (event) => {
            if (!dropDownClose.current.contains(event.target)) {
                setSelectedIndex(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    });


    const staticDropDownClose = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (staticDropDownClose.current && !staticDropDownClose.current.contains(event.target)) {
                setToggleOptionStatic(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    const applyfilter = (val) => {
        setFilterOption(val)
    }

    useDebouncedEffect(
        () => {
            onLoad(1, searchQuery)
        },
        [searchQuery],
        1000,
        { skipFirstRun: true }
    );

    const { mutateAsync: updateAssistantAccountDefault } = useUpdateAssistantAccountDefault();
    const handleToggleChangedefaultaccount = async (assistantId, profileId, currentState, assistant_type) => {
        const newState = !currentState; // Toggle the current state
        const { response, error } = await updateAssistantAccountDefault({
            assistantid: assistantId,
            profile_id: profileId,
            assitentdefault_value_change: newState,
            assistant_type: assistant_type
        });
        if (error) {
            console.error("Error updating assistant:", error);
            return;
        }
        console.log("Updated successfully");
        // Optionally refresh the data or update UI here
        onLoad();
    };
    const { mutateAsync: updateDefaultAssistantUi } = useUpdateDefaultAssistant();
    const handleToggleChangedefaultassistant = async (assistantid, currentState) => {
        const newState = !currentState; // Toggle the current state
        const { response, error } = await updateDefaultAssistantUi({
            assistantid: assistantid,
            ui_enable: newState // Send the new state
        });
        if (error) {
            console.error("Error updating assistant:", error);
            return;
        }
        console.log("Updated successfully");
        // Optionally refresh the data or update UI here
        onLoad();
    }

    if (!Array.isArray(currentItems)) {
        return (<>
            {waiting ? (<Loader />) : (<><div className="w-100" style={{ marginTop: "50px" }}>
                <div>
                    <div style={{ position: "absolute", left: "10px", top: "20px", maxWidth: "380px" }}>
                        <svg
                            width="25"
                            height="25"
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g clipPath="url(#clip0_282_92)">
                                <path
                                    d="M15 13.2955L12.3767 10.7727C13.1166 9.68182 13.5202 8.31818 13.5202 6.88636C13.5202 3.06818 10.4933 0 6.79372 0C3.09417 0 0 3.06818 0 6.88636C0 10.7045 3.02691 13.7727 6.79372 13.7727C8.27354 13.7727 9.61883 13.2955 10.6951 12.4773L13.3184 15.0682L15 13.2955ZM2.35426 6.88636C2.35426 4.43182 4.30493 2.45455 6.72646 2.45455C9.14798 2.45455 11.0987 4.43182 11.0987 6.88636C11.0987 9.34091 9.14798 11.3182 6.72646 11.3182C4.3722 11.3182 2.35426 9.34091 2.35426 6.88636Z"
                                    fill="#E5E5E5"
                                />
                            </g>
                            <defs>
                                <clipPath id="clip0_282_92">
                                    <rect width="15" height="15" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                    <input
                        type="text"
                        placeholder="Search by name..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        style={{
                            padding: "30px 45px",
                            width: "100%",
                            fontSize: "18px",
                            boxSizing: "border-box",
                            border: "1px solid #ccc",
                            borderRadius: "5px",
                            maxWidth: "380px"
                        }}
                    />
                </div>
                <div className="d-flex w-100">
                    <p className="p-20-px w-20-per text-left">Name</p>
                    {/* <p className="p-20-px w-20-per text-left">Tag</p> */}
                    <p className="p-20-px w-20-per text-left">Type</p>
                    <p className="p-20-px w-20-per text-left">Account Name</p>
                    <p className="p-20-px w-20-per text-left">User Name</p>
                    <p className="p-20-px w-20-per text-left">Date Created</p>

                    <p className="p-20-px w-20-per text-left"></p>
                </div>
                <div className="d-flex w-100">
                    <p className="w-100 text-center">data Not Found</p>

                </div>
            </div></>)
            }
        </>);
    }

    return (
        <>
            {waiting ? (
                <Loader />
            ) : (
                <>
                    {/* Search Input */}
                    <div style={{ position: "relative", marginBottom: "20px", display: "flex", justifyContent: "space-between" }}>
                        <div>
                            <div style={{ position: "absolute", left: "10px", top: "20px" }}>
                                <svg
                                    width="25"
                                    height="25"
                                    viewBox="0 0 15 15"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <g clipPath="url(#clip0_282_92)">
                                        <path
                                            d="M15 13.2955L12.3767 10.7727C13.1166 9.68182 13.5202 8.31818 13.5202 6.88636C13.5202 3.06818 10.4933 0 6.79372 0C3.09417 0 0 3.06818 0 6.88636C0 10.7045 3.02691 13.7727 6.79372 13.7727C8.27354 13.7727 9.61883 13.2955 10.6951 12.4773L13.3184 15.0682L15 13.2955ZM2.35426 6.88636C2.35426 4.43182 4.30493 2.45455 6.72646 2.45455C9.14798 2.45455 11.0987 4.43182 11.0987 6.88636C11.0987 9.34091 9.14798 11.3182 6.72646 11.3182C4.3722 11.3182 2.35426 9.34091 2.35426 6.88636Z"
                                            fill="#E5E5E5"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_282_92">
                                            <rect width="15" height="15" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>
                            <input
                                type="text"
                                placeholder="Search by name..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                style={{
                                    padding: "30px 45px",
                                    width: "100%",
                                    fontSize: "18px",
                                    boxSizing: "border-box",
                                    border: "1px solid #ccc",
                                    borderRadius: "5px",
                                }}
                            />
                        </div>
                        <div style={{ textAlign: "right" }}>
                            <div>
                                <div style={{ position: "absolute", left: "10px", top: "20px" }}>
                                    <svg
                                        width="25"
                                        height="25"
                                        viewBox="0 0 15 15"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <g clipPath="url(#clip0_282_92)">
                                            <path
                                                d="M15 13.2955L12.3767 10.7727C13.1166 9.68182 13.5202 8.31818 13.5202 6.88636C13.5202 3.06818 10.4933 0 6.79372 0C3.09417 0 0 3.06818 0 6.88636C0 10.7045 3.02691 13.7727 6.79372 13.7727C8.27354 13.7727 9.61883 13.2955 10.6951 12.4773L13.3184 15.0682L15 13.2955ZM2.35426 6.88636C2.35426 4.43182 4.30493 2.45455 6.72646 2.45455C9.14798 2.45455 11.0987 4.43182 11.0987 6.88636C11.0987 9.34091 9.14798 11.3182 6.72646 11.3182C4.3722 11.3182 2.35426 9.34091 2.35426 6.88636Z"
                                                fill="#E5E5E5"
                                            />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_282_92">
                                                <rect width="15" height="15" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </div>
                                <select
                                    value={filterOption}
                                    onChange={(e) => applyfilter(e.target.value)}
                                    style={{
                                        padding: "18px 57px",
                                        width: "100%",
                                        fontSize: "18px",
                                        boxSizing: "border-box",
                                        border: "1px solid #ccc",
                                        borderRadius: "5px",
                                    }}
                                >
                                    <option value="">Filter by...</option>
                                    <option value={"agency"}>All Accounts</option>
                                    <option value={"account"}>Account Specific</option>
                                    <option value={"user"}>User Specific</option>
                                    <option value={"automation"}>Automation</option>
                                    {/* Add more options as needed */}
                                </select>
                            </div>
                        </div>

                    </div>

                    <div className="w-100">
                        <div className="d-flex w-100">
                            <p className="p-20-px w-20-per text-left">Name</p>
                            {/* <p className="p-20-px w-20-per text-left">Tag</p> */}
                            <p className="p-20-px w-20-per text-left">Type</p>
                            {/* <p className="p-20-px w-20-per text-left">Category</p> */}
                            {/* <p className="p-20-px w-20-per text-left">Tags</p> */}
                            <p className="p-20-px w-20-per text-left">Account Name</p>
                            <p className="p-20-px w-20-per text-left">User Name</p>
                            <p className="p-20-px w-20-per text-left">Date Created</p>

                            <p className="p-20-px w-20-per text-left"></p>
                        </div>
                        <div>
                            {currentItems?.length > 0 ? (
                                currentItems
                                    .sort((a, b) => (a.assist_type === 'agency_task_gen' ? -1 : b.assist_type === 'agency_task_gen' ? 1 : 0))
                                    .map((item, index) => (
                                        <div className="equalheight d-flex w-100 tablebody-row" key={item._id || index}>
                                            <div className="p-20-px text-black text-bold text-left w-20-per">
                                                {item.assistant_name}
                                            </div>
                                            <div className="p-20-px text-black text-left w-20-per" style={{ textTransform: 'capitalize' }}>
                                                {
                                                    item?.assist_type === 'agency_task_gen'
                                                        ? 'Task Helper'
                                                        : item?.assist_type === 'agency'
                                                            ? 'All Account'
                                                            : filterOption === 'automation'
                                                                ? 'Automation'
                                                                : item?.assist_type
                                                }
                                            </div>

                                            {/* <div className="p-20-px text-black text-left w-20-per" style={{ display: 'flex', alignItems: 'center' }}>
                                                <span style={{ background: item?.category?.color, padding: '5px 15px', borderRadius: '20px', marginRight: '10px' }}> {(() => {
                                                    // Handle category as array - find category for current agency
                                                    let categoryToDisplay = null;

                                                    if (Array.isArray(item?.category)) {
                                                        categoryToDisplay = item.category.find(cat => cat.agency_id === agency._id);
                                                    } else if (item?.category && item?.category.agency_id === agency._id) {
                                                        // Handle legacy single category object
                                                        categoryToDisplay = item.category;
                                                    }

                                                    return categoryToDisplay ? (
                                                        <span style={{ background: categoryToDisplay?.color, padding: '5px 15px', borderRadius: '20px', marginRight: '10px' }}>
                                                            {categoryToDisplay?.name}
                                                        </span>
                                                    ) : null;
                                                })()}
                                                </span>
                                                <AddCategory item={item} handleRefresh={onLoad} />
                                            </div> */}
                                            {/* <div className="p-20-px text-black text-left w-20-per" style={{ display: 'flex', alignItems: 'center' }}>
                                                <span style={{ display: "flex" }}>
                                                    {item?.subCategory?.filter(cat => cat?.agency_id === agency._id && agency.SubCategories?.some(sub => cat.id === sub.id))?.slice(0, 1).map((data, index) => (
                                                        <span
                                                            key={index}
                                                            style={{ background: '#F3F4F6', padding: '5px 15px', borderRadius: '20px', marginRight: '10px', marginBottom: '5px', display: 'inline-flex', alignItems: 'center', gap: '8px' }}
                                                        >
                                                            {data?.name}
                                                        </span>
                                                    ))}

                                                    {item?.subCategory?.filter(cat => cat?.agency_id === agency._id && agency.SubCategories?.some(sub => cat.id === sub.id))?.length > 1 && (
                                                        <span
                                                            style={{ background: '#E7ECF3', padding: '5px 15px', borderRadius: '20px', marginRight: '10px', marginBottom: '5px', cursor: 'default' }}
                                                        >
                                                            {item?.subCategory?.filter(cat => cat?.agency_id === agency._id && agency.SubCategories?.some(sub => cat.id === sub.id))?.length - 1} more
                                                        </span>
                                                    )}
                                                </span>
                                                <AddSubCategory item={item} handleRefresh={onLoad} />
                                            </div> */}

                                            <div className="p-20-px text-black text-left w-20-per" style={{ overflow: "auto" }}>
                                                {item?.accounts?.map((account) => (<>

                                                    <span>{account?.business_name}</span>
                                                </>))}
                                            </div>
                                            <div className="p-20-px text-black text-left w-20-per" style={{ overflow: "auto" }}>

                                                {item?.chats_users?.map((user) => (<>

                                                    <span>{user?.userName}</span>
                                                </>))}
                                            </div>
                                            <div className="p-20-px text-black text-left w-20-per">
                                                {new Date(item?.createdAt).toLocaleString()}
                                            </div>

                                            <div className="p-20-px text-black text-right w-20-per">
                                                <div style={{ display: "flex", justifyContent: "center" }}>
                                                    {/* {(item?.assist_type === "account" || item?.assist_type === "agency") &&
                                                        <Tooltip title="Default Agent" arrow>
                                                            <FormControlLabel
                                                                control={
                                                                    <Switch
                                                                        checked={item?.finderofdefaultvalue?.default_assistant === undefined ? false : item?.finderofdefaultvalue?.default_assistant} // Ensure it defaults to `false` if undefined
                                                                        onChange={() => handleToggleChangedefaultaccount(
                                                                            item.assistant_id,
                                                                            item.profile_id,
                                                                            item?.finderofdefaultvalue?.default_assistant === undefined ? false : item?.finderofdefaultvalue?.default_assistant,
                                                                            item?.assist_type
                                                                        )}
                                                                    />
                                                                }
                                                                label=""
                                                            />
                                                        </Tooltip>
                                                    }
                                                    {
                                                        item?.assist_type !== 'agency_task_gen' && (
                                                            <Tooltip title="Chat UI" arrow>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Switch
                                                                            checked={item?.ui_enable}
                                                                            onChange={() => handleToggleChangedefaultassistant(
                                                                                item._id,
                                                                                item?.ui_enable // Pass current state
                                                                            )}
                                                                        />
                                                                    }
                                                                    label=""
                                                                />
                                                            </Tooltip>
                                                        )
                                                    } */}

                                                    {/* {item?.assist_type !== 'agency_task_gen' && (
                                                        <Tooltip title={item?.category ? "Chat UI" : "Add a category first"} arrow>
                                                            <FormControlLabel
                                                                control={
                                                                    <Switch
                                                                        checked={item?.ui_enable}
                                                                        onChange={() => handleToggleChangedefaultassistant(
                                                                            item._id,
                                                                            item?.ui_enable // Pass current state
                                                                        )}
                                                                        disabled={!item?.category} // Disable if no category
                                                                    />
                                                                }
                                                                label=""
                                                            />
                                                        </Tooltip>
                                                    )} */}
                                                    {/* {item?.assist_type !== 'agency_task_gen' && (
                                                        <Tooltip title="On/Off" arrow>
                                                            <FormControlLabel
                                                                control={
                                                                    <Switch
                                                                        checked={toggleCheckedState[item._id] || item?.status}
                                                                        onChange={() => handleToggleChange(item._id)}
                                                                    />
                                                                }
                                                                label=""
                                                            />
                                                        </Tooltip>
                                                    )} */}

                                                    {item?.assist_type !== 'agency_task_gen' && (
                                                        <Tooltip title="On/Off" arrow>
                                                            <FormControlLabel
                                                                control={
                                                                    <Switch
                                                                        checked={agency.superAdminAgents.includes(item._id)} // Check if the agent ID exists in superAdminAgents
                                                                        onChange={() => handleToggleChangeSuperAdmin(item._id)} // Call the toggle handler
                                                                    />
                                                                }
                                                                label=""
                                                            />
                                                        </Tooltip>
                                                    )}

                                                    {item.type !== 'super-admin' && (
                                                        <div style={{ display: "flex" }}>
                                                            {item?.readonly === true && (
                                                                <span
                                                                    className="cursor-pointer"
                                                                    onClick={() => handleToggle(index)}
                                                                    style={{ position: "relative" }}
                                                                >
                                                                    <Icon>upload</Icon>
                                                                    {selectedIndex === index && (
                                                                        <div className="v3_dropdown" ref={dropDownClose}>
                                                                            <span style={{ padding: "12px" }}>
                                                                                <FaLink style={{ marginRight: "7px", marginLeft: '4px' }} />
                                                                                <AddAWebsite assistant_id={item?.assistant_id} setSelectedIndex={setSelectedIndex} handlerRefresh={onLoad} />
                                                                            </span>
                                                                            <span>
                                                                                <img src={googleDrive} alt="googleDrive" style={{ marginRight: "7px" }} />
                                                                                <GoogleDrivePickers setSelectedIndex={setSelectedIndex} files_send_to_parent={files_recieved_from_child} assistant_id={item?.assistant_id} />
                                                                            </span>
                                                                            <span>
                                                                                <img src={dropBox} alt="Drop Box" style={{ marginRight: "7px" }} />
                                                                                <DropboxChooser setSelectedIndex={setSelectedIndex} files_send_to_parent={files_recieved_from_child} assistant_id={item?.assistant_id} />
                                                                            </span>
                                                                            <span
                                                                                onClick={() => {
                                                                                    setAlertModel(true);
                                                                                    setAddFileInAssistant(item?.assistant_id);
                                                                                }}
                                                                                style={{
                                                                                    borderBottom: "1px solid #E5E5E5",
                                                                                    borderTop: "1px solid #E5E5E5",
                                                                                }}
                                                                            >
                                                                                <div style={{ paddingRight: "7px" }}>
                                                                                    <UploadFileRounded fontSize="18px" />
                                                                                </div>
                                                                                Upload From Computer
                                                                            </span>


                                                                        </div>
                                                                    )}
                                                                </span>
                                                            )}
                                                            {item?.assist_type !== 'agency_task_gen' && (
                                                                <>
                                                                    <div className="cursor-pointer" style={{ margin: "0px 10px" }}>
                                                                        <EditModal item={item} handleRefresh={onLoad} supperAdminData={supperAdminData} assistant_type={item?.assist_type} pluginsdata={pluginsdata} />
                                                                    </div>
                                                                    <div className="cursor-pointer">
                                                                        <DeleteModal item={item} handleRefresh={onLoad} />
                                                                    </div>
                                                                </>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            </div >
                                        </div >
                                    ))
                            ) : (
                                <p className="text-center">No Assistant found</p>
                            )}
                        </div >
                    </div >

                    {/* Pagination Controls */}
                    < div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
                        <button
                            onClick={handlePreviousPage}
                            disabled={currentPage === 1}
                            style={{
                                padding: "8px 16px",
                                margin: "0 5px",
                                backgroundColor: "white",
                                color: "black",
                                border: "1px solid black",
                                borderRadius: "4px",
                                cursor: currentPage === 1 ? "not-allowed" : "pointer",
                                opacity: currentPage === 1 ? 0.6 : 1,
                            }}
                        >
                            Previous
                        </button>

                        {
                            [...Array(endPage - startPage + 1)]?.map((_, index) => {
                                const pageNumber = startPage + index;
                                return (
                                    <button
                                        key={pageNumber}
                                        onClick={() => handlePageChange(pageNumber)}
                                        style={{
                                            padding: "8px 16px",
                                            margin: "0 5px",
                                            backgroundColor: pageNumber === currentPage ? "black" : "white",
                                            color: pageNumber === currentPage ? "white" : "black",
                                            border: pageNumber === currentPage ? "1px solid white" : "1px solid black",
                                            borderRadius: "4px",
                                            cursor: "pointer",
                                        }}
                                    >
                                        {pageNumber}
                                    </button>
                                );
                            })
                        }

                        <button
                            onClick={handleNextPage}
                            disabled={currentPage === totalPages}
                            style={{
                                padding: "8px 16px",
                                margin: "0 5px",
                                backgroundColor: "white",
                                color: "black",
                                border: "1px solid black",
                                borderRadius: "4px",
                                cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                                opacity: currentPage === totalPages ? 0.6 : 1,
                            }}
                        >
                            Next
                        </button>
                    </div >
                    {alertModel && <>
                        <div className="modal-zz" onClick={() => setAlertModel(false)}>
                            <div className="modal-content-zz" onClick={(e) => e.stopPropagation()}>
                                <p
                                    style={{
                                        position: "absolute",
                                        right: 5,
                                        width: "12px",
                                        top: "10px",
                                        height: "12px",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => setAlertModel(false)}
                                >
                                </p>

                                <MyDropzone UploadFile={UploadFile} />
                            </div>
                        </div>
                    </>}
                    {
                        successModel && <>
                            <div className="modal-zz" onClick={() => setSuccessModel(false)}>
                                <div className="modal-content-zz" onClick={(e) => e.stopPropagation()}>
                                    <p style={{
                                        position: "absolute",
                                        right: 5,
                                        width: "12px",
                                        top: "10px",
                                        height: "12px",
                                        cursor: "pointer",
                                    }} onClick={() => setSuccessModel(false)}>
                                        X
                                    </p>
                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                        <img src={filesubnmitted} width={"200px"} height={"200px"} />
                                        <h1 className="text-center">File(s) are Submitted!</h1>
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                </>
            )
            }
        </>

    );
};

export default index
